export default __webpack_public_path__ + "static/media/magon-2-lounge-min.b2e38a07.jpg";